module.exports = __webpack_public_path__ + "static/works-futurehitfactory-0a2131ebd6d1b1f8118dae528eb7f9a4.jpg";